module.exports = __webpack_public_path__ + "img/yinhangb.a98fce62.png";